import { ResponsiveLine } from "@nivo/line";
import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";
import "./ChartTooltip.css";

const LineChartNivo = ({ data, yAxisText }) => {
  const { getAlterColor } = useContext(themeContext);
  const isPortraitMode = window.innerHeight > window.innerWidth && window.innerWidth >= 800;
  
  const formattedData = [
    {
      id: "Average TAT",
      data: data.map(item => ({
        x: item["x"],
        y: item["Average TAT"]
      }))
    }
  ];
  const convertSecondsToTime = (seconds) => {
    // const sec = parseInt(seconds, 10);
    // if (isNaN(sec)) return "00:00:00";

     const sec = Math.floor(Number(seconds));
  if (isNaN(sec) || sec < 0) return "00:00:00";

    const hrs = Math.floor(sec / 3600);
    const mins = Math.floor((sec % 3600) / 60);
    const secs = sec % 60;
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };


  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
    <div style={{ flex: 1, minHeight: 0 }}>
      <ResponsiveLine
        data={formattedData}
        margin={{ top: 10, right: isPortraitMode ? 20 : 130, bottom: 80, left: 80 }}
        lineWidth={3} 
        xScale={{ type: "point" }}
        yScale={{
          type: "linear",
          min: "auto",
          max: "auto",
          stacked: false,
          reverse: false
        }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 45,
          legend: "Reported Date",
          legendOffset: 70,
          legendPosition: "middle",
          format: (value) => {
            const date = new Date(value);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          }
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: yAxisText,
          legendOffset: -70,
          legendPosition: "middle",
          format: value => convertSecondsToTime(value)
        }}
        theme={{
          background: "none",
          axis: {
            fontSize: 14,
            tickColor: getAlterColor("#ffffff", "#000000"),
            ticks: {
              line: {
                stroke: "#555555"
              },
              text: {
                fill: getAlterColor("#ffffff", "#000000")
              }
            },
            legend: {
              text: {
                fill: getAlterColor("#ffffff", "#000000")
              }
            }
          },
          labels: {
            text: {
                fill: getAlterColor("#ffffff", "#000000"), // Point label color (numbers above dots)
                fontWeight: "bold"
            }
            },
          grid: {
            line: {
              stroke: "#555555"
            }
          },
          tooltip: {
            container: {
              background: "#ffffff",
              color: "#000000",
              fontSize: 13
            }
          }
        }}
        colors={{ scheme: "set2" }}
        pointSize={10}
        pointColor={getAlterColor("#ffffff", "#000000")}
        pointBorderWidth={2}
        pointBorderColor={{ from: "serieColor" }}
        enablePointLabel={true}
        pointLabelYOffset={-10}
        pointLabel={point =>  convertSecondsToTime(point.data.y)}
        tooltip={({ point }) => {
        const formatted = convertSecondsToTime(point.data.y);

        return (
          <div
            className=".tooltip-container-radiologist-tat-trend"
            style={{
              transform: `translate(${point.absoluteX}px, ${point.absoluteY}px)`
            }}
          >
            <div className="tooltip-container_in">
              <div className="tooltip-container_in__inside">
                <span
                  style={{
                    display: "block",
                    width: "12px",
                    height: "12px",
                    background: point.color,
                    marginRight: "7px"
                  }}
                ></span>
                <span style={{ color: "black" }}>
                  Average TAT: <strong>{formatted}</strong>
                </span>
              </div>
            </div>
          </div>
        );
      }}



        enableSlices={false}
        useMesh={true}
        legends={isPortraitMode ? [] : [
          {
            anchor: "top-right",
            direction: "column",
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 5,
            itemDirection: "left-to-right",
            itemWidth: 100,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: "circle",
            itemTextColor: getAlterColor("rgb(255,255,255,0.8)", "#000"),
            effects: [
              {
                on: "hover",
                style: {
                  itemTextColor: getAlterColor("#ffffff", "#000"),
                  itemOpacity: 1
                }
              }
            ]
          }
        ]}
      />
    </div>
    {isPortraitMode && (
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "8px 16px", padding: "6px 8px", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "13px", color: getAlterColor("rgb(255,255,255,0.8)", "#000") }}>
          <div style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#66c2a5", flexShrink: 0 }} />
          <span>Average TAT</span>
        </div>
      </div>
    )}
    </div>
  );
};

export default LineChartNivo;
